import { removeCookie } from "@insite/client-framework/Common/Cookies";
import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { deleteSession, stopWatchingForOtherTabSessionChange } from "@insite/client-framework/Services/SessionService";
import { chain, DeleteSession } from "@insite/client-framework/Store/Context/Handlers/SignOut";

type HandlerType = Handler;

export const DeleteSessionExtended: HandlerType = () => {
    stopWatchingForOtherTabSessionChange(); // Prevent reload caused by this sign-out, which could interfere with the RedirectToHomePage step.
    removeCookie("NavigationMode");
    // Remove UTM params from sessionStorage
    sessionStorage.removeItem("utm_campaign");
    sessionStorage.removeItem("utm_medium");
    sessionStorage.removeItem("utm_source");
    sessionStorage.removeItem("gclid");
    return deleteSession();
};

replaceInChain(chain, DeleteSession, DeleteSessionExtended);